import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit, Signal } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { select, Store } from '@ngxs/store';
import { AutocompleteModule } from '@sag-ui';
import { LoadCsrUsers } from '../../../user-management/state/user-management.action';
import { IUser } from '@cod-monorepo/interfaces';
import { UserState } from '../../../user-management/state/user-management.state';
import { tap } from 'rxjs';

@Component({
    selector: 'app-csr-responsible-select',
    templateUrl: './csr-responsible-select.component.html',
    imports: [CommonModule, AutocompleteModule, ReactiveFormsModule, FormsModule],
    standalone: true
})
export class CsrResponsibleSelectComponent implements OnInit {
    @Input({ required: true }) controlName: string;
    @Input({ required: true }) formGroup: FormGroup;

    public users: IUser[] = [];
    public loading: Signal<boolean> = select(UserState.csrLoading);

    private users$ = inject(Store).select(UserState.csrUsers);

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.initCsrUsers();
    }

    private initCsrUsers(): void {
        this.store.dispatch(new LoadCsrUsers());
        this.users$.pipe(tap(users => (this.users = users))).subscribe();
    }
}
